/*
  bback product gallery: 'Carousel with dots + arrows' layout
  - arrows step one image at a time (next wraps from the last photo back to the first)
  - no left arrow on the first photo
  - mouse: arrows only show while hovering the photos (CSS)
  - touch: arrows fade out briefly after a tap so they don't cover the image
  - dots show and jump to the current image
*/
(function () {
  if (window.bbGallery) return;
  window.bbGallery = true;

  var TOUCH_RESHOW_MS = 2500;

  function slidesOf(track) {
    return Array.prototype.slice.call(track.querySelectorAll('.product-gallery__slide'));
  }

  function currentIndex(track) {
    var slides = slidesOf(track);
    if (!slides.length) return 0;
    var base = slides[0].offsetLeft, best = 0, bestDist = Infinity;
    slides.forEach(function (s, i) {
      var d = Math.abs(s.offsetLeft - base - track.scrollLeft);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  function goTo(track, i) {
    var slides = slidesOf(track);
    if (!slides.length) return;
    if (i >= slides.length) i = 0;
    if (i < 0) i = 0;
    track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-bb-gallery]').forEach(function (wrap) {
      if (wrap.dataset.bbReady) return;
      wrap.dataset.bbReady = '1';
      var track = wrap.querySelector('media-carousel');
      var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-bb-dot]'));
      if (!track) return;

      function update() {
        var idx = currentIndex(track);
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        wrap.classList.toggle('bb-at-start', idx === 0);
      }
      update();

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });

      var reshowTimer = null;
      function hideArrowsBriefly() {
        wrap.classList.add('bb-arrows-hidden');
        clearTimeout(reshowTimer);
        reshowTimer = setTimeout(function () { wrap.classList.remove('bb-arrows-hidden'); }, TOUCH_RESHOW_MS);
      }

      var lastPointer = 'mouse';
      wrap.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });

      wrap.addEventListener('click', function (e) {
        var step = e.target.closest('[data-bb-gallery-step]');
        if (step) {
          goTo(track, currentIndex(track) + Number(step.getAttribute('data-bb-gallery-step')));
          if (e.detail !== 0 && lastPointer !== 'mouse') hideArrowsBriefly();
          return;
        }
        var dot = e.target.closest('[data-bb-dot]');
        if (dot) goTo(track, Number(dot.getAttribute('data-bb-dot')));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.bbGalleryInit = init;
})();
